'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUiSetPassword = exports.SET_PASSWORD_SUCCESS = exports.SET_PASSWORD_REQUEST = exports.SET_PASSWORD_FAIL = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.submitSetPassword = submitSetPassword;

var _user = require('./user');

var _api = require('../api');

var _reselect = require('reselect');

var _config = require('./config');

var _analytics = require('./analytics');

var _modal = require('./modal');

var _login = require('./login');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var SET_PASSWORD_FAIL = exports.SET_PASSWORD_FAIL = 'la/ui/setPassword/FAIL';
var SET_PASSWORD_REQUEST = exports.SET_PASSWORD_REQUEST = 'la/ui/setPassword/REQUEST';
var SET_PASSWORD_SUCCESS = exports.SET_PASSWORD_SUCCESS = 'la/ui/setPassword/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    errorMessage: '',
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SET_PASSWORD_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                errorMessage: action.payload.message,
                submitted: false,
                success: false
            });
        case SET_PASSWORD_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: false,
                errorMessage: '',
                submitted: true,
                success: false
            });
        case SET_PASSWORD_SUCCESS:
            return (0, _extends3.default)({}, state, {
                error: false,
                errorMessage: '',
                submitted: false,
                success: true
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.setPassword;
};

var getUiSetPassword = exports.getUiSetPassword = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
function setPasswordFail(emailAddress, error) {
    return {
        error: true,
        meta: { emailAddress: emailAddress },
        payload: error.error_message,
        type: SET_PASSWORD_FAIL
    };
}

function setPasswordRequest() {
    return {
        type: SET_PASSWORD_REQUEST
    };
}

function setPasswordSuccess(state, userDetails, attributionData) {
    return {
        // bidderID from token not response
        meta: (0, _extends3.default)({}, (0, _analytics.getSetPasswordAnalytics)(state, userDetails.bidderId, attributionData), {
            actionTime: Date.now()
        }),
        payload: userDetails,
        type: SET_PASSWORD_SUCCESS
    };
}

function submitSetPassword(password, attributionData) {
    return function (dispatch, getState) {
        var state = getState();
        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        var emailAddress = (0, _user.getBidderEmail)(state);
        var userData = (0, _user.getUserData)(state);
        dispatch(setPasswordRequest());
        return _api.Bidder.postSetPassword({ authToken: authToken, deployment: deployment, password: password }).then(function () {
            dispatch(setPasswordSuccess(getState(), userData, attributionData));
            dispatch((0, _login.submitLogin)(emailAddress, password)).then(function () {
                dispatch((0, _modal.openCompleteAccountModal)());
            });
        }).catch(function (error) {
            dispatch(setPasswordFail(emailAddress, error));
        });
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/setPassword.js
// module id = x7tz
// module chunks = 60